import { Empreendimento } from '../@types/empreendimento';
import aqilaApi from './aqila-api';

class Empreendimentos {
  private readonly endpoint = 'v1/empreendimentos';

  async list({ atividadeId, propriedadeId, safraId }: EmpreendimentosParams) {
    const params = {
      atividade: atividadeId,
      propriedade: propriedadeId,
      safra: safraId,
    };
    const { data } = await aqilaApi.get<Empreendimento[]>(this.endpoint, {
      params,
    });

    return data;
  }
}

type EmpreendimentosParams = {
  atividadeId?: number;
  propriedadeId?: number;
  safraId?: number;
};

export default new Empreendimentos();
